/* ══════════════════════════════════════════════════════════════════════
   Splash — product detail page behaviour

   Phase 1: gallery thumbs, variant picker (price + CTA follow the choice),
   install add-on, add-to-cart, bundle add, sticky buy bar.
   Phase 2 seams, live only when the flag rendered them: the ask bar and
   "See the math".

   This file never answers a question. Anything conversational is handed to
   Splash.Ripple (assets/splash-ripple.js), which owns the thinking state on
   every [data-ripple-mark] and the eventual response.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  var Splash = (window.Splash = window.Splash || {});

  function money(cents) {
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function init(root) {
    if (!root || root.dataset.spInit === 'true') return;
    root.dataset.spInit = 'true';

    /* ── Gallery thumbs ────────────────────────────────────────────── */
    var thumbs = [].slice.call(root.querySelectorAll('[data-thumb]'));
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) {
          t.classList.toggle('is-active', t === thumb);
          t.setAttribute('aria-pressed', t === thumb ? 'true' : 'false');
        });
      });
    });

    /* ── Variant picker ────────────────────────────────────────────────
       Price, CTA and sticky bar all read from the selected option, so they
       cannot disagree with each other. */
    var variants = [].slice.call(root.querySelectorAll('[data-variant]'));
    var priceEl = root.querySelector('.sp-buy__price');
    var ctaPrice = root.querySelector('[data-cta-price]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyVariant = document.querySelector('[data-sticky-variant]');

    function selectVariant(input) {
      variants.forEach(function (v) {
        v.closest('.sp-variant').classList.toggle('is-selected', v === input);
      });
      var cents = Number(input.dataset.priceCents);
      if (!cents) return;
      if (priceEl) priceEl.textContent = money(cents);
      if (ctaPrice) ctaPrice.textContent = money(cents);
      if (stickyPrice) stickyPrice.textContent = money(cents);
      if (stickyVariant) {
        /* Label reads "1.5 HP · $649" — the sticky bar wants just the size. */
        stickyVariant.textContent = ' · ' + input.value.split('·')[0].trim();
      }
    }

    variants.forEach(function (input) {
      input.addEventListener('change', function () {
        selectVariant(input);
      });
      if (input.checked) selectVariant(input);
    });

    /* ── Cart ──────────────────────────────────────────────────────── */
    function bumpCart(by) {
      var badge = document.querySelector('[data-cart-count]');
      var next = (Number(badge && badge.textContent) || 0) + by;
      if (Splash.Header && Splash.Header.setCartCount) Splash.Header.setCartCount(next);
      else if (badge) {
        badge.textContent = String(next);
        badge.hidden = false;
      }
    }

    function flash(button, label) {
      var original = button.textContent;
      button.textContent = label;
      setTimeout(function () {
        button.textContent = original;
      }, 1400);
    }

    document.addEventListener('click', function (event) {
      var add = event.target.closest('[data-add-to-cart]');
      if (add && (root.contains(add) || add.closest('[data-sticky-buy]'))) {
        event.preventDefault();
        /* The install add-on is a second line item when ticked. */
        var addon = root.querySelector('[data-install-addon]');
        bumpCart(addon && addon.checked ? 2 : 1);
        flash(add, 'Added');
        return;
      }

      var bundle = event.target.closest('[data-add-bundle]');
      if (bundle && root.contains(bundle)) {
        event.preventDefault();
        var items = root.querySelectorAll('.sp-bundle__item').length;
        bumpCart(items + 1); /* the parts plus the pump itself */
        flash(bundle, 'Added to cart');
      }
    });

    /* ── Sticky buy bar ────────────────────────────────────────────────
       Revealed only once the main CTA has left the viewport, so the coral
       Add is never on screen twice. */
    var mainCta = root.querySelector('.sp-cta-buy:not(.sp-cta-buy--slim)');
    var sticky = document.querySelector('[data-sticky-buy]');
    if (mainCta && sticky && window.IntersectionObserver) {
      new IntersectionObserver(
        function (entries) {
          var gone = !entries[0].isIntersecting;
          if (gone) {
            sticky.hidden = false;
            /* Next frame, so the transition has a start state to animate
               from rather than appearing already in place. */
            window.requestAnimationFrame(function () {
              sticky.classList.add('is-in');
            });
          } else {
            sticky.classList.remove('is-in');
            sticky.hidden = true;
          }
        },
        { threshold: 0 }
      ).observe(mainCta);
    }

    /* ── Phase 2 · ask bar ─────────────────────────────────────────────
       Hands the question to Ripple. No local answer, ever. */
    var ask = root.querySelector('[data-pdp-ask]');
    if (ask) {
      ask.addEventListener('submit', function (event) {
        event.preventDefault();
        var input = ask.querySelector('input');
        var text = (input.value || '').trim();
        if (!text) {
          input.focus();
          return;
        }
        if (Splash.Ripple) Splash.Ripple.query(text, { source: 'pdp' });
      });
    }

    var seeMath = root.querySelector('[data-see-math]');
    if (seeMath) {
      seeMath.addEventListener('click', function () {
        if (Splash.Ripple) {
          Splash.Ripple.open({ source: 'pdp-see-math', topic: 'energy-savings-calculation' });
        }
      });
    }
  }

  function boot() {
    [].slice.call(document.querySelectorAll('[data-pdp]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
